import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";
import { Button, Modal, Col, Row, Card, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import ApiAuth from "../../../core/api/api.auth";
import ContextApp from "../../../core/contexts/context.app";
import SwalMessage from "../_Components/SwalMessage";
import VerifyMobile from "./Components/VerifyMobile";
import { PatternFormat } from "react-number-format";
import { PersonPlusFill } from "react-bootstrap-icons";
const Register = () => {
  const [loadingBtnLogin, setLoadingBtnLogin] = useState(false);
  const ctx = useContext(ContextApp);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({ defaultValues: { id: 0 } });
  const [stateVerificationForm, setStateVerificationForm] = useState(false);
  const [mobileLogin, setMobileLogin] = useState("");

  const onSubmit = async (data) => {
    setLoadingBtnLogin(true);
    try {
      data.phoneNumber = data.phoneNumber.replaceAll(" ", "");

      const response = await ApiAuth.register(data);
      if (response.succeeded == true) {
        setStateVerificationForm(true);
        setMobileLogin(data.phoneNumber);
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } else
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
      console.log("error=", error);
    } finally {
      setLoadingBtnLogin(false);
    }
  };
  return (
    <div
      className="w-100 h-100 pb-5"
      style={{
        overflow: isMobile ? "scroll" : "hidden",
        backgroundColor: isMobile ? "#ffffff" : "#f1f6f9",
      }}
    >
      {!stateVerificationForm ? (
        <div>
          {" "}
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            {isMobile ? (
              <div>
                <div className="text-center">
                  {" "}
                  <img
                    style={{ height: "200px" }}
                    src="/media/bg/Traveling-rafiki-withouttext.png"
                  />
                </div>
                <h1 className="text-center mt-0" style={{ color: "#407bff" }}>
                  تفریحان
                </h1>
                <p className="text-muted text-center">
                  سامانه رزرو تفریحات کیش با تخفیف
                </p>
                <div className="mx-5" style={{ marginTop: "4rem" }}>
                  <div
                    className="pb-5 px-5 shadow-sm rounded-4"
                    style={{ backgroundColor: "#eff2f3" }}
                  >
                    <div
                      className="mx-auto"
                      style={{
                        backgroundColor: "#eff2f3",
                        borderRadius: "50%",
                        height: "60px",
                        width: "60px",
                        position: "relative",
                        top: "-20px",
                        bottom: "0px",
                      }}
                    >
                      {" "}
                      <PersonPlusFill
                        className="mx-2 my-1"
                        color="#3699ff"
                        size={45}
                      />
                    </div>
                    <h5
                      className="text-center mb-2"
                      style={{ color: "#91919b" }}
                    >
                      ایجاد حساب تامین کننده
                    </h5>
                    <div className=" ">
                      <Controller
                        name="firstName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام"
                            id="firstName"
                            margin="normal"
                            variant="standard"
                            size="small"
                            value={value || ""}
                            onChange={onChange}
                            autoComplete="true"
                            className=" removeAutofillStyleLoginInput"
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            InputProps={{ style: { fontSize: "14px" } }}
                          />
                        )}
                      />
                      {errors.firstName && (
                        <small className="text-danger">
                          لطفا نام را وارد نمایید
                        </small>
                      )}

                      <Controller
                        name="lastName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام خانوادگی"
                            margin="normal"
                            variant="standard"
                            size="small"
                            value={value || ""}
                            onChange={onChange}
                            className="removeAutofillStyleLoginInputMobile "
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            InputProps={{ style: { fontSize: "14px" } }}
                          />
                        )}
                      />
                      {errors.lastName && (
                        <small className="text-danger">
                          لطفا نام خانوادگی را وارد نمایید
                        </small>
                      )}

                      <Controller
                        name="phoneNumber"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <PatternFormat
                            customInput={TextField}
                            label="شماره موبایل"
                            size="small"
                            margin="normal"
                            value={value || ""}
                            variant="standard"
                            dir="ltr"
                            //   thousandSeparator=","
                            decimalScale="0"
                            //prefix=" تومان "
                            //maxLength={value[0] === '0' ? 13 : 12}
                            format="#### ### ####"
                            onChange={onChange}
                            className="removeAutofillStyleLoginInputMobile"
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            InputProps={{ style: { fontSize: "14px" } }}
                          />
                        )}
                      />
                      {errors.phoneNumber && (
                        <small className="text-danger">
                          لطفا شماره موبایل را وارد نمایید
                        </small>
                      )}
                    </div>

                    <div className=" text-center my-5">
                      {loadingBtnLogin ? (
                        <Button
                          className="w-100"
                          variant="primary"
                          type="submit"
                          style={{ fontSize: "14px" }}
                          disabled
                        >
                          <Spinner size="sm" />
                          ثبت نام
                        </Button>
                      ) : (
                        <Button
                          className="w-100"
                          variant="primary"
                          type="submit"
                          style={{ fontSize: "14px" }}
                        >
                          ثبت نام
                        </Button>
                      )}
                    </div>
                    <div className=" px-0  text-center">
                      <Link
                        to="/login"
                        className="text-gray mb-5"
                        style={{ fontSize: "12px" }}
                      >
                        {" "}
                        قبلا ثبت نام کرده اید؟برای
                        <strong
                          className="mx-1 text-primary"
                          style={{ fontSize: "14px" }}
                        >
                          {" "}
                          ورود{" "}
                        </strong>
                        کلیک کنید
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // </div>

              <div className="d-flex">
                <Col
                  lg="4"
                  className="p-5 my-auto"
                  style={{ marginTop: "6rem", marginRight: "5rem" }}
                >
                  <div
                    className="m-5 pb-5  shadow-sm  rounded-4"
                    style={{ backgroundColor: "#fafbff" }}
                  >
                    <div
                      className="mx-auto"
                      style={{
                        backgroundColor: "#fafbff",
                        borderRadius: "50%",
                        height: "80px",
                        width: "80px",
                        position: "relative",
                        top: "-30px",
                        bottom: "0px",
                      }}
                    >
                      {" "}
                      <PersonPlusFill
                        className="mx-2 my-2"
                        color="#3699ff"
                        size={60}
                      />
                    </div>
                    {/* <img/>  this is user icon of form */}

                    <h5
                      className="text-center mb-5"
                      style={{ color: "#91919b" }}
                    >
                      ایجاد حساب تامین کننده
                    </h5>
                    <div className="mx-5">
                      <Controller
                        name="firstName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام"
                            id="firstName"
                            margin="normal"
                            variant="standard"
                            size="small"
                            value={value || ""}
                            onChange={onChange}
                            autoComplete="true"
                            className=" removeAutofillStyleLoginInput"
                          />
                        )}
                      />
                      {errors.firstName && (
                        <small className="text-danger">
                          لطفا نام را وارد نمایید
                        </small>
                      )}

                      <Controller
                        name="lastName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام خانوادگی"
                            margin="normal"
                            variant="standard"
                            size="small"
                            value={value || ""}
                            onChange={onChange}
                            className="removeAutofillStyleLoginInput "
                          />
                        )}
                      />
                      {errors.lastName && (
                        <small className="text-danger">
                          لطفا نام خانوادگی را وارد نمایید
                        </small>
                      )}

                      <Controller
                        name="phoneNumber"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <PatternFormat
                            customInput={TextField}
                            label="شماره موبایل"
                            size="small"
                            margin="normal"
                            value={value || ""}
                            variant="standard"
                            dir="ltr"
                            thousandSeparator=","
                            decimalScale="0"
                            //prefix=" تومان "
                            //maxLength={value[0] === '0' ? 13 : 12}
                            format="#### ### ####"
                            onChange={onChange}
                            className="removeAutofillStyleLoginInput"
                          />
                        )}
                      />
                      {errors.phoneNumber && (
                        <small className="text-danger">
                          لطفا شماره موبایل را وارد نمایید
                        </small>
                      )}
                    </div>
                    <div className="mx-5  text-center my-5">
                      {loadingBtnLogin ? (
                        <Button
                          className="w-100"
                          variant="primary"
                          type="submit"
                          disabled
                        >
                          <Spinner size="sm" />
                          ثبت نام
                        </Button>
                      ) : (
                        <Button
                          className="w-100"
                          variant="primary"
                          type="submit"
                        >
                          ثبت نام
                        </Button>
                      )}
                    </div>
                    <div className=" mx-5 px-5  text-center">
                      <Link
                        to="/login"
                        className="text-muted mb-5"
                        style={{ fontSize: "12px" }}
                      >
                        قبلا ثبت نام کرده اید؟برای ورود
                        <strong
                          className="mx-1 text-primary"
                          style={{ fontSize: "12px" }}
                        >
                          کلیک کنید
                        </strong>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col>
                  {" "}
                  <img
                    style={{ width: "90% ", height: "90%", float: "left" }}
                    src="/media/bg/Traveling-rafiki.png"
                  />
                </Col>
              </div>
            )}
          </form>
        </div>
      ) : (
        <VerifyMobile mobileLogin={mobileLogin} />
      )}
    </div>
  );
};

export default Register;
